import styled, { css } from 'styled-components';
import { AssetsListContainer } from '../../common/AssetsList/styles';
import Container from '../../common/Container';
import { ContainerStyled, ContainerContentStyled, } from '../../common/Container/styles';
const ColumnStyle = ({ $percentSplit, $isWithAssets, }) => css `
  ${$isWithAssets
    ? `
    grid-template-columns: 1fr;
    grid-template-rows: ${`${$percentSplit}fr ${100 - $percentSplit}fr`};
    align-items: stretch;
  `
    : `
    display:flex;
    flex-direction:column;
    `}

  gap: 40px;

  ${ContainerStyled}:first-of-type {
    ${ContainerContentStyled} {
      padding-bottom: 0;
    }
  }
  ${ContainerStyled}:last-of-type {
    ${ContainerContentStyled} {
      padding-top: 0;
    }
  }
`;
const RowStyle = css `
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: ${({ $percentSplit }) => `${$percentSplit}fr ${100 - $percentSplit}fr`};
  align-items: center;
  gap: 80px;
`;
export const StyledGroupOf2 = styled(Container) `
  display: grid;

  ${({ $direction }) => ($direction === 'column' ? ColumnStyle : RowStyle)}
  ${({ $minHeight }) => !!$minHeight ? `min-height: ${$minHeight}px;` : `min-height: 0;`};

  ${AssetsListContainer} {
    align-self: center;
    ${({ $minHeight }) => !!$minHeight ? `min-height: ${$minHeight}px;` : undefined};
  }

  & > * {
    position: relative;
    z-index: 1;

    iframe {
      height: 100% !important;
    }
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.l}px) {
    ${({ $minHeight, $minHeightMobile, $isWithAssets }) => $isWithAssets
    ? ` 
          gap: 32px;
          display: flex;
          flex-direction: column-reverse;
        `
    : !!$minHeight || $minHeightMobile || !$isWithAssets
        ? ` 
          gap: 56px;
          display: flex;
          flex-direction: column;
        `
        : ColumnStyle};

    ${AssetsListContainer} {
      ${({ $minHeight, $minHeightMobile }) => !!$minHeightMobile
    ? `height: ${$minHeightMobile}px;`
    : !!$minHeight
        ? `height: ${$minHeight}px;`
        : undefined};
    }
  }
`;
